export const PeridioCityTerminologies = {
  7: "Weekly",
  14: "Fortnightly",
  30: "Monthly",
  90: "Quarterly",
  180: "Half-yearly",
  365: "Yearly",
};

const checkValueInNumericRangeArray = (numericRangeArray, value) => {
  for (let i = 0; i < numericRangeArray.length; i++) {
    let rangeObj = numericRangeArray[i];
    let maxVal = Number(rangeObj.max);
    let minVal = Number(rangeObj.min);
    if (value <= maxVal && value >= minVal) {
      return true;
    }
  }
};
const getNumericSeverity = (analyticsRanges, value) => {
  let numericalSeverity = null;
  Object.entries(analyticsRanges).forEach(([severity, severityNumericRangeArray]) => {
    if (checkValueInNumericRangeArray(severityNumericRangeArray, value)) {
      numericalSeverity = severity;
    }
  });
  return numericalSeverity ? `is_${numericalSeverity}` : "";
};

const getCategoricalSeverity = (analyticsRanges, value) => {
  let categoricalSeverity = null;
  Object.entries(analyticsRanges).forEach(([severity, severityRangeValusArray]) => {
    if (severityRangeValusArray.includes(value)) {
      categoricalSeverity = severity;
    }
  });
  return categoricalSeverity ? `is_${categoricalSeverity}` : "";
};


const getAnalyticsClass = (analyticsObj, value) => {
  const analyticsType = analyticsObj.type;
  const analyticsRanges = analyticsObj.ranges;
  if (analyticsType === "numeric") {
    return getNumericSeverity(analyticsRanges, value);
  }
  if (analyticsType === "categorical") {
    return getCategoricalSeverity(analyticsRanges, value);
  }
};

function isAttachmentFieldFunc(fieldType) {
  return fieldType === "attachment" || fieldType === "image_capture"
}

export const getClassesForColumn = (param, fieldPacket) => {
  const rowData = param.row;
  const columnKey = param.field;
  const columnValue = rowData[columnKey];
  const fieldType = fieldPacket.type;
  const isAttachmentField = isAttachmentFieldFunc(fieldType);
  const hasAnalyticsInfo = fieldPacket.analyticsData;
  if (isAttachmentField) {
    if (columnValue && columnValue?.length > 0) {
      return 'blue pointer';
    } else {
      return 'noAttachment'
    }
  }
  if (hasAnalyticsInfo) {
    const analyticsClass = getAnalyticsClass(fieldPacket.analyticsData, columnValue);
    return analyticsClass;
  }
  return "normalCell";
};



export const extractColsFromMaintenanceForm = (fieldList , showInTableColsOnly) => {
  console.log("fieldList", fieldList);
  if (!fieldList || fieldList.length === 0) {
    return [];
  }

  let columns = [];

  fieldList?.forEach((field, i) => {
    if (field.type !== "heading" && field.type !== "sub_heading") {
      if (field.type === "section" || field.type === "reactive_section") {
        columns = [...columns, ...extractColsFromMaintenanceForm(field.sectionFields,showInTableColsOnly)];
      } else {
       let showInTableCheck= showInTableColsOnly?field.showInTable: true
        if (field.key !== "completedDt" && showInTableCheck) {
          columns.push({
            field: field.key,
            headerName: field.label,
            sortable: true,
            minWidth: 210,
            hideable: true,
            isAttachment: isAttachmentFieldFunc(field.type),
            flex: 1,
            renderCell: (param) => {
              if (isAttachmentFieldFunc(field.type)) {
                return "Attachments";
              } else if (!param.value || param.value === "") {
                return "-";
              }
            },
            cellClassName: (param) => {
              return getClassesForColumn(param, field);
            },
          });
        }
      }
    }
  });

  console.log("columns", columns);

  return columns;
};